<h1>
  <span id='breadcrumbs' *ngFor="let item of validatedParts; let i = index">
    <span *ngIf="i > 0">/</span>
    <a href (click)="goToLoc(item.data)" *ngIf="i < validatedParts.length - 1 && item.data">{{ item.name }}</a>
    <span
      *ngIf="i == validatedParts.length - 1 || !item.data"
      [ngStyle]="{ 'font-weight': i === validatedParts.length - 1 ? 'bold' : '' }"
      >{{ item.name }}</span
    >
  </span>
</h1>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/breadcrumb/breadcrumb.component.html